module.exports = __webpack_public_path__ + "mz.svg?780f485924a159d4dd2963470f90ddfd";